<template>
    <ul class="space-y-4">
        <li v-if="allOption">
            <label class="flex items-center relative cursor-pointer">
                <input
                    :checked="!hasValue"
                    class="absolute opacity-0"
                    type="checkbox"
                    @change="onAllCheck">
                <span
                    :class="{'rounded-full': !multiple}"
                    class="flex justify-center items-center w-6 h-6 mr-3 border border-grey-light">
                       <font-awesome-icon
                           v-if="multiple"
                           :class="{'opacity-0': hasValue}"
                           class="text-primary"
                           icon="check"/>
                        <span v-else :class="{'opacity-0': hasValue}" class="bg-primary w-3 h-3 rounded-full"/>
                </span>
                <span class="leading-6">All</span>
            </label>
        </li>
        <li v-for="(label, v) in options">
            <label class="flex items-center relative cursor-pointer">
                <input
                    v-if="multiple"
                    v-model="model"
                    class="absolute opacity-0"
                    type="checkbox"
                    :value="v">
                <input
                    v-else
                    v-model="model"
                    class="absolute opacity-0"
                    type="radio"
                    :value="v">
                <span
                    :class="{'rounded-full': !multiple}"
                    class="flex justify-center items-center w-6 h-6 mr-3 border border-grey-light">
                        <font-awesome-icon
                            v-if="multiple"
                            :class="{'opacity-0': !isChecked(v)}"
                            class="text-primary"
                            icon="check"/>
                        <span
                            v-else
                            :class="{'opacity-0': !isChecked(v)}"
                            class="bg-primary w-3 h-3 rounded-full"/>
                    </span>
                <span class="leading-6">{{ label }}</span>
            </label>
        </li>
    </ul>
</template>

<script>

export default {

    props: {
        options: {
            type: Object,
            required: true
        },
        value: {
            required: true
        },
        allOption: {
            type: Boolean,
            default: true
        },
    },

    methods: {
        onAllCheck() {
            this.model = this.multiple ? [] : '';
        },
        isChecked(value) {
            if (this.multiple) {
                return this.value.includes(value);
            }

            return _.isEqual(this.value, value);
        }
    },

    computed: {
        multiple() {
            return _.isArray(this.value);
        },
        hasValue() {
            if (this.multiple) {
                return this.value.length > 0;
            }

            return !!this.value;
        },
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        }
    }
};

</script>
